import Splide from "@splidejs/splide";

document.addEventListener('DOMContentLoaded', function () {
  const splide = new Splide('.testimonials-slider', {
    type: 'slide',
    perPage: 1,
    focus: 0,
    fixedWidth: '100%',
    gap: '1rem',
    arrows: false,
    pagination: false,
    speed: 500,
    mediaQuery: 'min',
    breakpoints: {
      768: {
        padding: { left: '8rem', right: '8rem' },
        gap: '6rem',
      },
      1200: {
        gap: '13.2rem',
        padding: { left: '21.7rem', right: '21.7rem' },
      },
      1920: {
        gap: '14rem',
        padding: { left: '24rem', right: '24rem' },
      },
      2560: {
        gap: '16rem',
        padding: { left: '32rem', right: '32rem' },
      }
    }
  }).mount();

  const tabs = document.querySelectorAll('.testimonials-tab');
  const tabsContainer = document.querySelector('.testimonials-tabs');

  const isMobile = () => window.matchMedia('(max-width: 767px)').matches;

  const centerTab = (tab, smooth = true) => {
    if (!isMobile() || !tabsContainer) return;

    const scrollLeft =
      tab.offsetLeft - (tabsContainer.clientWidth / 2) + (tab.clientWidth / 2);

    tabsContainer.scrollTo({
      left: scrollLeft,
      behavior: smooth ? 'smooth' : 'instant',
    });
  };

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      splide.go(parseInt(tab.dataset.index, 10));
    });
  });

  splide.on('move', (newIndex) => {
    tabs.forEach((tab) => {
      tab.classList.remove('is-active');
      tab.setAttribute('aria-selected', 'false');
    });

    const activeTab = tabs[newIndex];
    activeTab.classList.add('is-active');
    activeTab.setAttribute('aria-selected', 'true');

    centerTab(activeTab, true);
  });

  const initialTab = document.querySelector('.testimonials-tab.is-active');
  if (initialTab) {
    setTimeout(() => centerTab(initialTab, false), 50);
  }
});